import store from "../../store";

export default function pwaGuest({ next, router }) {
	if (store.getters["pwaAuth/pwaIsAuthenticated"]) {
		return router.push({ name: "Pwa Dashboard" });
	}

	return next();
}
